import { useEffect } from 'react';
import type {
  JobSearchParams,
  JobsResponse,
} from 'src/apis/transparency-reporting/types';
import { useAxios } from 'src/hooks/use-axios';

export const JOB_SEARCH_URL = `${PRISMA_CONFIG.transparencyReporting}/jobs`;

type HookConfig = {
  jobSearchUrl: string;
  params: JobSearchParams;
};

type ExecuteProps = {
  url: string;
  params: JobSearchParams;
};

export function useJobSearch({ jobSearchUrl, params }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: ExecuteProps) =>
      axios.request<JobsResponse>({
        ...baseConfig,
        url,
        params,
      }),
    { neededOnPageLoad: false }
  );

  useEffect(() => {
    request.execute({ url: jobSearchUrl, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [jobSearchUrl, params]);

  return request;
}

export type JobSearchRequest = ReturnType<typeof useJobSearch>;
